import { render, staticRenderFns } from "./confirm.component.vue?vue&type=template&id=4c41c2ac"
import script from "./confirm.component.ts?vue&type=script&lang=ts&external"
export * from "./confirm.component.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports